var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Modal',{attrs:{"width":"400","value":_vm.value,"title":_vm.title,"subtitle":_vm.subtitleText,"cta-text":_vm.ctaText,"dialog-icon":_vm.dialogIcon,"hide-actions":_vm.hideActions},on:{"confirm":_vm.confirm,"cancel":_vm.cancel}})}
var staticRenderFns = []

export { render, staticRenderFns }